import { render, staticRenderFns } from "./SaveFieldsTable.vue?vue&type=template&id=523c4737&"
import script from "./SaveFieldsTable.vue?vue&type=script&lang=js&"
export * from "./SaveFieldsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports